export default class ContactForm {
  private contactByPhone = document.getElementById('contactByPhone');

  constructor() {
    this.initContactForm();
    this.showTextbox();
  }

  showTextbox() {
    let checkboxActive = <HTMLInputElement>document.querySelector('.js-checkboxactive');
    let showTextfield = <HTMLInputElement>document.querySelector('.js-activeForm');
    this.contactByPhone?.addEventListener('change', () => {
      let isChecked = checkboxActive.checked; // Check;
      showTextfield.disabled = !isChecked;
      showTextfield.required = isChecked;
      if (isChecked) {
        showTextfield.classList.remove('input__text--deactive');
      } else {
        showTextfield.classList.add('input__text--deactive');
      }
    });
  }

  initContactForm() {
    const contactFormWrapper = document.querySelector('.js-contactFormWrapper');
    const validationResult = document.querySelector('.js-validationResult');

    const validationError = validationResult?.querySelectorAll('.field-error');

    if (!(contactFormWrapper instanceof HTMLElement)) {
      return;
    }
    if (!(validationResult instanceof HTMLElement)) {
      return;
    }
    const gotoPage1Button = contactFormWrapper.querySelector('.js-contactFormGotoPage1');
    const gotoPage2Button = contactFormWrapper.querySelector('.js-contactFormGotoPage2');

    if (!(gotoPage2Button instanceof HTMLElement)) {
      return;
    }
    gotoPage2Button.addEventListener('click', () => {
      validationResult.classList.remove('hide');
      contactFormWrapper.classList.add('contactFormWrapper--showPage2');
      contactFormWrapper.classList.remove('contactFormWrapper--showPage1');
      window.dispatchEvent(new Event('resize'));
    });

    if (!(gotoPage1Button instanceof HTMLElement)) {
      return;
    }
    gotoPage1Button.addEventListener('click', () => {
      validationResult.classList.add('hide');
      contactFormWrapper.classList.add('contactFormWrapper--showPage1');
      contactFormWrapper.classList.remove('contactFormWrapper--showPage2');
    });
    //go to page 2 if form values are invalid
    if (validationError?.length) {
      gotoPage2Button.click();
    }
  }
}
